import { useState } from 'react';
import { Modal, Input } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

export default function ModalRechazarOp({ visible, onClose, onConfirm, loading }) {
const [motivoRechazo, setMotivoRechazo] = useState('')

const handleOk = () => {
  if (motivoRechazo.trim()) {
    onConfirm(motivoRechazo)
  }
}

const handleCancel = () => {
  setMotivoRechazo('')
  onClose()
}

return (
  <Modal
    title={
      <span>
        <CloseCircleOutlined style={{ marginRight: 8 }} />
        Rechazar Orden de Pago
      </span>
    }
    open={visible}
    onOk={handleOk}
    onCancel={handleCancel}
    confirmLoading={loading}
    okText="Rechazar"
    cancelText="Cerrar"
    okButtonProps={{ disabled: !motivoRechazo.trim(), danger: true }}
    className="pagos-v2-modal"
    >
      <p>Escribe el motivo por el cual se rechaza esta orden de pago:</p>
      <Input.TextArea
      rows={3}
      value={motivoRechazo}
      onChange={(e) => setMotivoRechazo(e.target.value)}
      placeholder="Motivo de rechazo.."
      />
    </Modal>
  )
}